import { Link } from 'react-router-dom';
import type { News } from '@/types/media';

interface NewsSpotlightProps {
  items: News[];
}

export default function NewsSpotlight({ items }: NewsSpotlightProps) {
  const [featured, ...rest] = items;

  return (
    <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
      {featured && (
        <Link
          to={`/news/${featured.id}`}
          className="group flex flex-col overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70 transition-all duration-300 hover:ring-accent-300"
        >
          <div className="h-52 w-full overflow-hidden bg-background-200 md:h-64">
            <img
              src={featured.cover}
              alt={featured.title}
              title={`${featured.title} - 八戒影院影视资讯`}
              className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex flex-1 flex-col p-4 md:p-5">
            <div className="flex items-center gap-2 text-xs text-foreground-500">
              <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-700">{featured.category}</span>
              <span>{featured.date}</span>
            </div>
            <h3 className="mt-2 line-clamp-2 text-lg font-bold text-foreground-950 transition-colors group-hover:text-accent-600 font-heading">
              {featured.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{featured.summary}</p>
          </div>
        </Link>
      )}

      <div className="flex flex-col gap-3">
        {rest.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex gap-3 rounded-lg bg-background-50 p-3 ring-1 ring-background-200/70 transition-all duration-300 hover:ring-accent-300"
          >
            <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={item.cover}
                alt={item.title}
                title={`${item.title} - 八戒影院影视资讯`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span className="text-accent-600">{item.category}</span>
                <span>{item.date}</span>
              </div>
              <h3 className="mt-1 line-clamp-2 text-sm font-semibold text-foreground-950 transition-colors group-hover:text-accent-600">
                {item.title}
              </h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}